import 'material-symbols';
import 'front-commons/constructors';
import 'front-commons/entities';
import 'front-commons/constructors';
import 'front-commons/prototypes';
import './styles/reset.css';
import 'hype-ds/styles/global.css';
import 'shared/gtm/api';
import 'shared/api';
import 'shared/storage';
import 'stores/entity';
import 'front-commons/entities';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './stores/store';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ElasticAPMProvider } from 'contexts/ApmElastic';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<ElasticAPMProvider>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_KEY_V3}>
					<App />
				</GoogleReCaptchaProvider>
			</PersistGate>
		</Provider>
	</ElasticAPMProvider>,
);

reportWebVitals();
